import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManagerState } from './manager.state';

export const selectManagerState = createFeatureSelector<ManagerState>('manager');

export const selectManagedCompanies = createSelector(selectManagerState, state => state.managedCompanies);
export const selectLoadingManagedCompanies = createSelector(selectManagerState, state => state.loadingManagedCompanies);
export const selectProcesses = createSelector(selectManagerState, state => state.processes);
export const selectProcessesPagination = createSelector(selectManagerState, state => state.processesPagination);
export const selectLoadingProcesses = createSelector(selectManagerState, state => state.loadingProcesses);

export const selectCandidateVerifications = createSelector(selectManagerState, state => state.candidateVerifications);
export const selectCandidateVerificationsPagination = createSelector(
  selectManagerState,
  state => state.candidateVerificationsPagination
);
export const selectLoadingCandidateVerifications = createSelector(
  selectManagerState,
  state => state.loadingCandidateVerifications
);

export const selectCandidateVerificationDetails = createSelector(
  selectManagerState,
  state => state.candidateVerificationDetails
);
export const selectLoadingCandidateVerificationDetails = createSelector(
  selectManagerState,
  state => state.loadingCandidateVerificationDetails
);
export const selectLoadingCandidateVerificationProcedureDecision = createSelector(
  selectManagerState,
  state => state.loadingCandidateVerificationProcedureDecision
);

export const selectCandidateVerificationHistory = createSelector(
  selectManagerState,
  state => state.candidateVerificationHistory
);
export const selectLoadingCandidateVerificationHistory = createSelector(
  selectManagerState,
  state => state.loadingCandidateVerificationHistory
);
